module.exports = __webpack_public_path__ + "img/sombe.347acb97.png";